/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-07-29 20:40:30
 * @LastEditTime: 2020-08-21 21:16:52
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/account.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */

import {
  getTableHeaderApi,
  getTableDataApi,
  getHomeDataApi,
  getChangeDataApi,
  deleteDataApi,
  postDataApi,
  getUserApi,
  getUserItemApi
} from "@/service/tableService";

const account = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getTableHeader(store, id) {
      return new Promise((resolve, reject) => {
        getTableHeaderApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getTableData(store, idInfo) {
      return new Promise((resolve, reject) => {
        getTableDataApi(idInfo)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getHomeData(store, id) {
      return new Promise((resolve, reject) => {
        getHomeDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getChangeData(store, data) {
      return new Promise((resolve, reject) => {
        getChangeDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteData(store, id) {
      return new Promise((resolve, reject) => {
        deleteDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    postData(store, data) {
      return new Promise((resolve, reject) => {
        postDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUser(store, id) {
      return new Promise((resolve, reject) => {
        getUserApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUserItem(store, id) {
      return new Promise((resolve, reject) => {
        getUserItemApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default account;



// WEBPACK FOOTER //
// ./src/store/modules/account.js